<div class="basin-content-window basin-scroll-container-vertical">
  <div class="p-grid">
    <div class="p-col-12">
      <div class="basin-display-flex basin-mb-6">
        <div class="basin-display-flex basin-align-items-center">
          <h4>Simulations Dashboard</h4>
        </div>
      </div>
      <div class="basin-mb-6">
        <app-simulation-tracker-table
          [simulationDaysRetained]="retentionDays"
          [simulationItems$]="simulationTrackerItems$"
        >
        </app-simulation-tracker-table>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog styleClass="small" header="Confirmation" [dismissableMask]="true" [closable]="true"></p-confirmDialog>
